import React from "react";
import { Col, Row, UiImage, UiSimpleGrid, UiText, UiWrap, useBreakpointValue } from "~/components/elements";

import maternityBedroom from "~/assets/img/v2/available-styles/maternity_bedroom.jpg";
import maternityDusk from "~/assets/img/v2/available-styles/maternity_dusk.jpg";
import maternityMoonlit from "~/assets/img/v2/available-styles/maternity_moonlit.jpg";
import maternityStudio from "~/assets/img/v2/available-styles/maternity_studio.jpg";
import maternitySunrise from "~/assets/img/v2/available-styles/maternity_sunrise.jpg";
import patrioticFlagMural from "~/assets/img/v2/available-styles/patriotic_flag_mural.jpg";
import patrioticMonument from "~/assets/img/v2/available-styles/patriotic_monument.jpg";
import patrioticOffice from "~/assets/img/v2/available-styles/patriotic_office.jpg";
import patrioticOutdoors from "~/assets/img/v2/available-styles/patriotic_outdoors.jpg";
import patrioticStudio from "~/assets/img/v2/available-styles/patriotic_studio.jpg";
import seasonalChristmas from "~/assets/img/v2/available-styles/seasonal_christmas.jpg";
import seasonalFall from "~/assets/img/v2/available-styles/seasonal_fall.jpg";
import seasonalHalloween from "~/assets/img/v2/available-styles/seasonal_halloween.jpg";
import seasonalLifestyle from "~/assets/img/v2/available-styles/seasonal_lifestyle.jpg";
import seasonalWinter from "~/assets/img/v2/available-styles/seasonal_winter.jpg";

import autumnPark from "~/assets/img/v2/available-styles/autumn_park.jpg";
import beach from "~/assets/img/v2/available-styles/beach.jpg";
import birthday from "~/assets/img/v2/available-styles/birthday.jpg";
import cafe from "~/assets/img/v2/available-styles/cafe.jpg";
import city from "~/assets/img/v2/available-styles/city.jpg";
import darkGrey from "~/assets/img/v2/available-styles/dark_grey.jpg";
import graduation from "~/assets/img/v2/available-styles/graduation.jpg";
import medicalPro from "~/assets/img/v2/available-styles/medical_pro.jpg";
import office from "~/assets/img/v2/available-styles/office.jpg";
import plainWhite from "~/assets/img/v2/available-styles/plain_white.jpg";

import aubergine from "~/assets/img/v2/available-styles/aubergine.jpg";
import beachBlueHour from "~/assets/img/v2/available-styles/beach_blue_hour.jpg";
import beachSunrise from "~/assets/img/v2/available-styles/beach_sunrise.jpg";
import darkGreyBg from "~/assets/img/v2/available-styles/dark_grey_bg.jpg";
import emeraldGreen from "~/assets/img/v2/available-styles/emerald_green.jpg";
import garden from "~/assets/img/v2/available-styles/garden.jpg";
import lightGrey from "~/assets/img/v2/available-styles/light_grey.jpg";
import outdoorForest from "~/assets/img/v2/available-styles/outdoor_forest.jpg";
import trail from "~/assets/img/v2/available-styles/trail.jpg";
import whiteBg from "~/assets/img/v2/available-styles/white_background.jpg";

import groupBy from "lodash/groupBy";
import { PhotoshootType } from "~/types/models/dashboard";

export type AvailableStyleType = {
  img: any;
  outfit: string;
  bg: string;
  is_all_access: boolean;
};

const upsellStyles: AvailableStyleType[] = [
  { img: plainWhite, outfit: "", bg: "Plain White Background", is_all_access: false },
  { img: city, outfit: "", bg: "City", is_all_access: false },
  { img: graduation, outfit: "", bg: "Graduation", is_all_access: false },
  { img: autumnPark, outfit: "", bg: "Autumn Park", is_all_access: false },
  { img: cafe, outfit: "", bg: "Cafe", is_all_access: false },
  { img: medicalPro, outfit: "", bg: "Medical Professional", is_all_access: false },
  { img: beach, outfit: "", bg: "Beach", is_all_access: false },
  { img: office, outfit: "", bg: "Office", is_all_access: false },
  { img: darkGrey, outfit: "", bg: "Dark Grey Background", is_all_access: false },
  { img: birthday, outfit: "", bg: "Birthday", is_all_access: false },
];
const twoPersonUpsellStyles: AvailableStyleType[] = [
  { img: aubergine, outfit: "", bg: "Aubergine", is_all_access: false },
  { img: beachBlueHour, outfit: "", bg: "Beach Blue Hour", is_all_access: false },
  { img: beachSunrise, outfit: "", bg: "Beach Sunrise", is_all_access: false },
  { img: darkGreyBg, outfit: "", bg: "Dark Grey", is_all_access: false },
  { img: emeraldGreen, outfit: "", bg: "Emerald Green", is_all_access: false },
  { img: garden, outfit: "", bg: "Garden", is_all_access: false },
  { img: lightGrey, outfit: "", bg: "Light Grey", is_all_access: false },
  { img: outdoorForest, outfit: "", bg: "Outdoor Forest", is_all_access: false },
  { img: trail, outfit: "", bg: "Trail", is_all_access: false },
  { img: whiteBg, outfit: "", bg: "White Background", is_all_access: false },
];

const allAccessStyles: AvailableStyleType[] = [
  { img: seasonalFall, outfit: "Seasonal", bg: "Fall", is_all_access: true },
  { img: seasonalChristmas, outfit: "Seasonal", bg: "Christmas", is_all_access: true },
  { img: seasonalHalloween, outfit: "Seasonal", bg: "Halloween", is_all_access: true },
  { img: seasonalWinter, outfit: "Seasonal", bg: "Winter", is_all_access: true },
  { img: seasonalLifestyle, outfit: "Seasonal", bg: "Lifestyle", is_all_access: true },
  { img: maternityDusk, outfit: "Maternity", bg: "Dusk Silhouette", is_all_access: true },
  { img: maternityBedroom, outfit: "Maternity", bg: "Bedroom Silhouette", is_all_access: true },
  { img: maternitySunrise, outfit: "Maternity", bg: "Sunrise Silhouette", is_all_access: true },
  { img: maternityStudio, outfit: "Maternity", bg: "Studio Silhouette", is_all_access: true },
  { img: maternityMoonlit, outfit: "Maternity", bg: "Moonlit Silhouette", is_all_access: true },
  { img: patrioticMonument, outfit: "Patriotic", bg: "Monument", is_all_access: true },
  { img: patrioticOutdoors, outfit: "Patriotic", bg: "Outdoors", is_all_access: true },
  { img: patrioticFlagMural, outfit: "Patriotic", bg: "Flag Mural", is_all_access: true },
  { img: patrioticOffice, outfit: "Patriotic", bg: "Office", is_all_access: true },
  { img: patrioticStudio, outfit: "Patriotic", bg: "Studio", is_all_access: true },
];

export function GridStyle({
  item,
  hideOutfit = false,
  maxSize = 11.875,
}: {
  item: AvailableStyleType;
  hideOutfit?: boolean;
  maxSize?: number;
}) {
  return (
    <Col
      minW={{ base: "undefined", sm: `${maxSize * 0.85}rem` }}
      minH={{ base: "undefined", sm: `${maxSize * 0.85}11.875rem` }}
      maxW={{ base: "undefined", sm: `${maxSize}rem` }}
      maxH={{ base: "undefined", sm: `${maxSize}rem` }}
      borderRadius="16px"
      pos="relative"
      aspectRatio={1}
    >
      <UiImage
        src={item.img}
        containerClasses="flex1 h-full"
        h="full"
        w="full"
        objectFit="cover"
        objectPosition="top"
        borderRadius="16px"
      />
      <Col rounded="16px" pos="absolute" left={0} right={0} bottom={0} px={2} pb={2} className="gradient-col">
        {!hideOutfit && (
          <UiText textAlign="left" noOfLines={2} color="white" vr="body2" fontWeight="bold">
            {item.outfit}
          </UiText>
        )}
        <UiText textAlign="left" noOfLines={2} color="white" vr="body2" fontWeight="bold">
          {item.bg}
        </UiText>
        {item.is_all_access && (
          <Row align="center">
            <UiText vr="title2" className="gradient-text" noOfLines={1}>
              All access&nbsp;
            </UiText>
            <UiText as="span" fontSize="11px" mb="2px">
              ⭐
            </UiText>
          </Row>
        )}
      </Col>
    </Col>
  );
}

export const AvailableStyles: React.FC<{
  type: "upsell" | "all_access";
  groupByOutfit?: boolean;
  photoshootType: PhotoshootType;
}> = ({ type, photoshootType, groupByOutfit = false }) => {
  const Container = useBreakpointValue<any>({ base: UiSimpleGrid, sm: UiWrap });

  let data: AvailableStyleType[];
  if (type === "upsell") {
    data = photoshootType === "two_person" ? twoPersonUpsellStyles : upsellStyles;
  } else {
    data = allAccessStyles;
  }
  const groupedData = groupByOutfit ? groupBy(data, "outfit") : undefined;

  return (
    <Col pb={2}>
      {!groupByOutfit && (
        <Container columns={2} gap={{ base: 4, sm: 3 }} w="full" pb={2}>
          {data.map((item, idx) => (
            <GridStyle key={idx} item={item} />
          ))}
        </Container>
      )}
      {groupByOutfit &&
        groupedData &&
        Object.keys(groupedData).map((outfit, idx) => (
          <Col mb={3}>
            <UiText vr="title2" mb={2}>
              {outfit}
            </UiText>
            <Container spacing="1rem" columns={2} gap={{ base: 4, sm: 3 }} w="full" pb={2}>
              {groupedData[outfit].map((item, idx2) => (
                <GridStyle key={idx2} item={item} hideOutfit />
              ))}
            </Container>
          </Col>
        ))}
    </Col>
  );
};
